import React, { useEffect } from 'react';
import { Panel } from 'primereact/panel';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { userPassportDetailsRecords } from '../../services/common/states';
import { useNavigate } from 'react-router';
import { useFormik } from 'formik';
import { setTravelTab } from '../../services/store/userSlice';
import { useDispatch } from 'react-redux';
import TravelDataTable from './travel-datatable';
import moment from 'moment';
const PassportDetails = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        userPassportDetailsRecords.subscribe((result) => {
            console.log(result, "userPassportDetailsRecords subscribe ");
            if (result) {
                searchForm.setValues({
                    passportNumber: result.passportNumber,
                    dateOfBirth: result.dateOfBirth ? moment(result.dateOfBirth).toDate() : null,
                    placeOfIssue: result.placeOfIssue,
                    dateOfIssue: result.dateOfIssue ? moment(result.dateOfIssue).toDate() : null,
                    dateOfExpire: result.dateOfExpire ? moment(result.dateOfExpire).toDate() : null,
                    addressAsPerPassport: result.addressAsPerPassport
                });
            }
        });
    }, []);

    const searchForm = useFormik({
        initialValues: {
            passportNumber: '',
            dateOfBirth: null,
            placeOfIssue: '',
            dateOfIssue: null,
            dateOfExpire: null,
            addressAsPerPassport: ''
        },
        validate: (data) => {
            let errors = {};
            if (!data.passportNumber) {
                errors.passportNumber = 'Enter Passport Number';
            }
            if (!data.dateOfBirth) {
                errors.dateOfBirth = 'Enter Date Of Birth';
            }
            if (!data.placeOfIssue) {
                errors.placeOfIssue = 'Enter Place Of Issue';
            }
            if (!data.dateOfIssue) {
                errors.dateOfIssue = 'Enter Date Of Issue';
            }
            if (!data.dateOfExpire) {
                errors.dateOfExpire = 'Enter Date Of Expire';
            }
            if (!data.addressAsPerPassport) {
                errors.addressAsPerPassport = 'Enter Address As Per Passport';
            }
            return errors;
        },
        onSubmit: (data) => {
            saveUserTravelRecords(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(searchForm.touched[name] && searchForm.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{searchForm.errors[name]}</small>
            )
        );
    };

    const saveUserTravelRecords = (data) => {
        const formattedData = {
            ...data,
            dateOfBirth: moment(data.dateOfBirth).format('YYYY-MM-DD'),
            dateOfIssue: moment(data.dateOfIssue).format('YYYY-MM-DD'),
            dateOfExpire: moment(data.dateOfExpire).format('YYYY-MM-DD')
        };
        console.log(formattedData, "saveUserTravelRecords");
        dispatch(setTravelTab(3));
        userPassportDetailsRecords.next(formattedData);
    }

    return (
        <div className="tabview-demo">
            <form onSubmit={searchForm.handleSubmit} autoComplete='off'>
                <Panel>
                    <div className="formgrid grid">
                        <div className="field col-3">
                            <label htmlFor="passportNumber" className="font-bold block mb-2">Passport Number</label>
                            <InputText
                                id="passportNumber"
                                name="passportNumber"
                                placeholder="Passport Number"
                                value={searchForm.values.passportNumber}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("passportNumber")}
                        </div>

                        <div className="field col-3">
                            <label htmlFor="dateOfBirth" className="font-bold block mb-2">Date of Birth</label>
                            <Calendar
                                id="dateOfBirth"
                                name="dateOfBirth"
                                value={searchForm.values.dateOfBirth}
                                onChange={(e) => searchForm.setFieldValue('dateOfBirth', e.value)}
                                readOnlyInput
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                showIcon
                                placeholder="Date of Birth"
                                className="w-100"
                            />
                            {getFormErrorMessage("dateOfBirth")}
                        </div>

                        <div className="field col-3">
                            <label htmlFor="placeOfIssue" className="font-bold block mb-2">Place of Issue</label>
                            <InputText
                                id="placeOfIssue"
                                name="placeOfIssue"
                                placeholder="Place of Issue"
                                value={searchForm.values.placeOfIssue}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("placeOfIssue")}
                        </div>

                        <div className="field col-3">
                            <label htmlFor="dateOfIssue" className="font-bold block mb-2">Date of Issue</label>
                            <Calendar

                                id="dateOfIssue"
                                name="dateOfIssue"
                                value={searchForm.values.dateOfBirth}
                                onChange={(e) => searchForm.setFieldValue('dateOfIssue', e.value)}
                                readOnlyInput
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                showIcon
                                placeholder="Date of Issue"
                                className="w-100"
                            />
                            {getFormErrorMessage("dateOfIssue")}
                        </div>

                        <div className="field col-3">
                            <label htmlFor="dateOfExpire" className="font-bold block mb-2">Date of Expire</label>
                            <Calendar
                                id="dateOfExpire"
                                name="dateOfExpire"
                                value={searchForm.values.dateOfBirth}
                                onChange={(e) => searchForm.setFieldValue('dateOfExpire', e.value)}
                                readOnlyInput
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                showIcon
                                placeholder="Date of Expire"
                                className="w-100"
                            />
                            {getFormErrorMessage("dateOfExpire")}
                        </div>

                        <div className="field col-12">
                            <label htmlFor="addressAsPerPassport" className="font-bold block mb-2">Address as per the Passport</label>
                            <InputTextarea
                                id="addressAsPerPassport"
                                name="addressAsPerPassport"
                                value={searchForm.values.addressAsPerPassport}
                                onChange={searchForm.handleChange}
                                rows={7}
                                className="w-100"
                            />
                            {getFormErrorMessage("addressAsPerPassport")}
                            <span style={{ float: "right" }}>150 Characters Left</span>
                        </div>
                    </div>
                </Panel>
                <Panel>
                    <div className="formgrid grid">
                        {/* <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Previous" icon="pi pi-arrow-circle-left" aria-label="Save" severity="secondary" type='submit' />
                        </div> */}
                        {/* <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Save as draft" icon="pi pi-inbox" aria-label="Save" severity="primary" type='submit' />
                        </div> */}
                        <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Save & Next" icon="pi pi-save" aria-label="Save" severity="success" type='submit' />
                        </div>
                    </div>
                </Panel>
            </form>
            <Panel>
                <TravelDataTable />
            </Panel>
        </div>
    );
}

export default PassportDetails;
